import MobileBottom from "./MobileBottom";

export default MobileBottom;
